var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mb-3 card" }, [
    _vm.value.name
      ? _c("div", { staticClass: "card-header bg-secondary-3" }, [
          _vm.value.letter
            ? _c(
                "div",
                {
                  staticClass:
                    "rounded letter-box mr-2 d-inline-flex align-items-center justify-content-center",
                  style: {
                    color: _vm.value.letterColor || "white",
                    backgroundColor:
                      `${_vm.value.letterColor}14` || "#2db78226",
                    borderColor: _vm.value.letterColor || "#2db782"
                  }
                },
                [_c("i", { class: _vm.value.letter || "fas fa-question" })]
              )
            : _vm._e(),
          _c("b", { staticClass: "mr-2" }, [
            _vm._v(_vm._s(_vm._f("empty")(_vm.value.name)) + ":")
          ])
        ])
      : _vm._e(),
    _c("div", { staticClass: "card-body bg-secondary-3" }, [
      _c(
        "div",
        { staticClass: "mb-3" },
        _vm._l(_vm.value.types, function(type) {
          return _c(
            "div",
            { key: type.id },
            _vm._l(type.options, function(option) {
              return _c(
                "div",
                { key: option.id },
                [
                  _c("label", { staticClass: "data-name" }, [
                    _vm._v(_vm._s(option.name) + ":")
                  ]),
                  _c("validation-provider", {
                    attrs: { rules: _vm.isRequired ? "required" : "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-text-area", {
                                attrs: {
                                  "count-classes": [
                                    "d-block",
                                    "small-counter",
                                    "text-right"
                                  ],
                                  "custom-error-msg": "El campo es requerido.",
                                  disabled: _vm.isReadOnly,
                                  error: errors[0],
                                  maxlength: 5000,
                                  "show-char-count": !_vm.isReadOnly
                                },
                                model: {
                                  value: option.value,
                                  callback: function($$v) {
                                    _vm.$set(option, "value", $$v)
                                  },
                                  expression: "option.value"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                ],
                1
              )
            }),
            0
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }